// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.welcome-button {
  display: flex;
  flex-direction: row;
  padding: 16px 12px 24px 12px;
  justify-content: space-between;
  height: 93px;
  border: 1px solid #dddddd;
  border-radius: 5px;
  margin-bottom: 26px;
}
.welcome-button:hover {
  box-shadow: 0 4px 14px 0 rgba(0, 0, 0, 0.2);
  cursor: pointer;
}
.welcome-button:last-of-type {
  margin-bottom: 0;
}
.welcome-button__text {
  font-weight: 600;
  font-size: 14px;
  letter-spacing: 1px;
  color: #1a1e22;
  text-transform: uppercase;
  margin-top: 12px;
}
.welcome-button__arrow {
  transform: rotate(-90deg);
  width: 16px;
  height: 11px;
  align-self: center;
}
@media (min-width: 400px) {
  .welcome-button {
    padding: 16px 24px 24px 24px;
  }
  .welcome-button__text {
    font-weight: 600;
    font-size: 18px;
    letter-spacing: 1.3px;
  }
}
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.welcome-header {
  width: 100%;
}
.welcome-header__content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.875rem 0;
  height: auto;
  box-shadow: none;
  width: 100%;
  margin: 0 auto;
}
.welcome-header__logo {
  width: auto;
  height: 4.375rem;
}
.welcome-header__phone-button {
  font-size: 14px;
  margin-left: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1.25rem;
  border-radius: 3.5rem;
  font-weight: 600;
  text-align: center;
  line-height: 1.5rem;
  transition: all 0.2s;
  cursor: pointer;
  border: none;
}
.welcome-header__phone-icon {
  max-width: 2rem;
  max-height: 2rem;
}
.welcome-header--simple {
  padding: 0 1rem;
  position: sticky;
  top: 0;
  z-index: 100;
  background-color: #ffffff;
  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.1);
}
@media (min-width: 750px) {
  .welcome-header--simple {
    position: relative;
    border-bottom: 1px solid #d9d9d9;
    box-shadow: none;
  }
}
.welcome-header--simple .welcome-header__content {
  max-width: 37.5rem;
}
@media (min-width: 1300px) {
  .welcome-header--simple .welcome-header__content {
    max-width: 80rem;
  }
}
.welcome-header--simple .welcome-header__phone-button {
  background-color: #e6f5ee;
  color: #3d7c54;
}
.welcome-header--simple .welcome-header__phone-button:focus-visible, .welcome-header--simple .welcome-header__phone-button:hover {
  background-color: #3d7c54;
  color: #ffffff;
}
.welcome-header--pop {
  background: transparent;
}
.welcome-header--pop .welcome-header__content {
  max-width: var(--hero-max-width);
}
.welcome-header--pop .welcome-header__phone-button {
  background-color: #ffffff;
  color: #3d7c54;
}
.welcome-header--pop .welcome-header__phone-button:focus-visible, .welcome-header--pop .welcome-header__phone-button:hover {
  background-color: #e6f5ee;
}
.welcome-feature-list {
  display: grid;
  grid-template-columns: max-content 1fr;
  gap: 0.75rem 1.5rem;
  margin: 0 !important;
  align-items: center;
  font-size: 1rem;
  line-height: 1.25;
  color: #1a1e22;
}
.welcome-feature-list:has(.welcome-feature-list__title) {
  gap: 2rem 1.5rem;
}
.welcome-feature-list:has(.welcome-feature-list__title) .welcome-feature-list__item {
  grid-template-rows: auto auto;
}
.welcome-feature-list__item {
  display: grid;
  grid-column: 1/-1;
  grid-template-columns: subgrid;
  margin-bottom: 0 !important;
  align-items: center;
}
.welcome-feature-list__icon {
  width: 3rem;
  height: 3rem;
  grid-column: 1/span 1;
  grid-row: 1/-1;
  align-self: start;
}
.welcome-feature-list__icon img {
  width: 100%;
  height: 100%;
}
.welcome-feature-list__title {
  display: block;
  font-weight: 700;
  margin-bottom: 0.75rem;
  grid-column: 2/span 1;
}
.welcome-feature-list__copy {
  grid-column: 2/span 1;
}
.welcome-feature-list__copy sup {
  color: #4e7b57;
}
.welcome-heading {
  --eyebrow-color: #246464;
  --title-color: #000000;
  margin-bottom: 1rem;
}
.welcome-heading__eyebrow {
  margin-bottom: 0.5rem;
  color: var(--eyebrow-color);
  font-size: 0.875rem;
  line-height: 1.2;
  font-weight: 600;
  margin-bottom: 0.5625rem;
  text-transform: uppercase;
  letter-spacing: 0.125rem;
}
.welcome-heading__title {
  font-weight: 600;
  color: var(--title-color);
}
.welcome-heading__title:where(h1) {
  font-size: 1.75rem;
  line-height: 1.25;
}
@media (min-width: 750px) {
  .welcome-heading__title:where(h1) {
    font-size: 2.25rem;
  }
}
.welcome-heading__title:where(h2) {
  font-size: 1.3125rem;
  line-height: 1.5;
}
.welcome-heading--white {
  --eyebrow-color: #ffffff;
  --title-color: #ffffff;
}
.testimonials__container {
  position: relative;
  min-width: 0;
  min-height: 0;
}
.testimonials__card {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  border-radius: 1rem;
  padding: 1rem 1.25rem;
}
.testimonials__content {
  font-size: 1rem;
  line-height: 1.625;
  color: #000000;
}
.testimonials__citation {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
}
.testimonials__reviewer {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 1rem;
  line-height: 1.5;
}
.testimonials__avatar {
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  background-color: #e0f2ea;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #2a805b;
  font-weight: bold;
  font-size: 1.25rem;
  flex: 0 0 auto;
}
.testimonials__name {
  font-size: 1.125rem;
  flex: 1 1 auto;
}
.testimonials__date {
  color: #595959;
}
.testimonials__rating {
  display: flex;
  align-items: center;
  gap: 0.125rem;
}
.testimonials__source {
  font-size: 0.75rem;
  color: #595959;
}
.testimonials__link {
  text-decoration: underline;
}
.testimonials__nav-container {
  display: flex;
  justify-content: center;
  margin-top: 1rem;
  gap: 1rem;
}
.testimonials__arrow {
  position: static;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.2s ease;
  background-color: #4e7b57;
  color: white;
}
.testimonials__arrow:focus-visible, .testimonials__arrow:hover {
  background-color: #246464;
}
.testimonials__arrow svg {
  width: 2rem;
  height: 2rem;
}
.react-multi-carousel-list {
  padding: 0;
}
.welcome-back-to-top {
  font-size: 14px;
  padding: calc(1rem - 1px);
  border-radius: 3.5rem;
  font-weight: 600;
  text-align: center;
  line-height: 1.5rem;
  transition: all 0.2s;
  cursor: pointer;
  border: 1px solid #3d7c54;
  background-color: transparent;
  color: #3d7c54;
  min-width: 10rem;
}
.welcome-back-to-top:focus-visible, .welcome-back-to-top:hover {
  background-color: #3d7c54;
  color: white;
}
.welcome-footer {
  max-width: 100%;
  width: 100%;
  padding: 2.5rem 1rem 2rem;
  align-self: end;
  text-wrap: pretty;
}
.welcome-footer__disclaimer {
  color: #5d5d5e;
  font-size: 0.625rem;
  line-height: 2;
  margin: 0 auto 2rem;
  max-width: 58.25rem;
}
.welcome-footer__disclaimer ol {
  padding-left: 1rem;
}
.welcome-footer__disclaimer li {
  list-style-type: auto;
  width: 100%;
}
.welcome-footer__disclaimer li::marker {
  color: #4e7b57;
  font-weight: 700;
}
.welcome-footer .footer__compliance-container {
  max-width: 100%;
  width: 100%;
}
.welcome-pop {
  --hero-max-width: 30.75rem;
  --content-max-width: 30.75rem;
}
@media (min-width: 950px) {
  .welcome-pop {
    --hero-max-width: 70rem;
  }
}
@media (min-width: 1100px) {
  .welcome-pop {
    --content-max-width: 70rem;
  }
}
.welcome-pop__hero {
  background: radial-gradient(at 60% bottom, rgb(18, 84, 42) 0%, rgb(61, 124, 84) 100%);
  padding: 0 1.5rem;
  position: relative;
  margin-bottom: 3.75rem;
}
@media (min-width: 950px) {
  .welcome-pop__hero {
    padding-bottom: 4.75rem;
    margin-bottom: 1px;
  }
}
@media (min-width: 1100px) {
  .welcome-pop__hero {
    padding-bottom: 3.75rem;
  }
}
.welcome-pop__hero-bg-image {
  width: 100%;
  overflow: hidden;
  height: 12.75rem;
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  z-index: 0;
}
.welcome-pop__hero-bg-image svg {
  width: 90rem;
  height: 100%;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
}
@media (min-width: 90em) {
  .welcome-pop__hero-bg-image svg {
    width: 100%;
  }
}
.welcome-pop__hero-layout {
  max-width: var(--hero-max-width);
  margin: 0 auto;
  padding-top: 1.5rem;
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;
  z-index: 1;
  position: relative;
}
@media (min-width: 950px) {
  .welcome-pop__hero-layout {
    grid-template-columns: 1fr 1fr;
    gap: 2.5rem;
    padding-top: 3rem;
  }
}
@media (min-width: 1100px) {
  .welcome-pop__hero-layout {
    padding-top: 1rem;
  }
}
.welcome-pop__hero-left {
  max-width: 29.5rem;
  color: #ffffff;
}
@media (min-width: 950px) {
  .welcome-pop__hero-left .welcome-heading__eyebrow {
    margin-bottom: 1.25rem;
  }
}
.welcome-pop__hero-left .welcome-heading__title {
  text-wrap: pretty;
}
@media (min-width: 1100px) {
  .welcome-pop__hero-left .welcome-heading__title {
    font-size: 3rem;
  }
}
.welcome-pop__hero-description {
  font-size: 1rem;
  line-height: 1.625;
}
@media (min-width: 1300px) {
  .welcome-pop__hero-description {
    font-size: 1.3125rem;
    line-height: 1.2;
  }
}
.welcome-pop__hero-card {
  background-color: #fff;
  border-radius: 1rem;
  box-shadow: 0 0.25rem 0.25rem rgba(0, 0, 0, 0.25);
  padding: 1.5rem 1.5rem 2rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}
@media (min-width: 750px) {
  .welcome-pop__hero-card {
    padding: 1.5rem 2.5rem 2rem;
  }
}
@media (min-width: 950px) {
  .welcome-pop__hero-card {
    padding: 1.5rem 2rem 1.5rem;
    box-shadow: 0 0.25rem 1rem rgba(0, 0, 0, 0.2);
  }
}
@media (min-width: 1100px) {
  .welcome-pop__hero-card {
    padding: 2rem 2.5rem;
  }
}
@media (min-width: 1100px) {
  .welcome-pop__hero-card {
    padding: 2rem 3rem;
  }
}
.welcome-pop__hero-card-title {
  margin: 0;
  font-size: 1.3125rem;
  line-height: 1.5;
  font-weight: 600;
  margin-bottom: 0.375rem;
}
@media (min-width: 1100px) {
  .welcome-pop__hero-card-title {
    font-size: 2.25rem;
    line-height: 1.3;
    margin-bottom: 0;
  }
}
.welcome-pop__hero-card-description {
  font-size: 1rem;
  line-height: 1.625;
}
.welcome-pop__cta-buttons {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}
.welcome-pop .welcome-button {
  padding: 1rem 1.5rem;
  margin: 0;
  width: 100%;
  align-items: center;
  gap: 1rem;
  display: grid;
  grid-template-columns: auto 1fr max-content;
  height: auto;
  padding: 1rem;
  text-align: left;
}
@media (min-width: 750px) {
  .welcome-pop .welcome-button {
    padding: 1rem 1.5rem;
    gap: 1.5rem;
  }
}
.welcome-pop .welcome-button img {
  max-height: 2.5rem;
  max-width: 3rem;
}
@media (min-width: 750px) {
  .welcome-pop .welcome-button img {
    max-width: 100%;
  }
}
.welcome-pop .welcome-button__text {
  margin-top: 0;
  line-height: 1;
  text-box: trim-both cap alphabetic;
}
.welcome-pop__hero-card-login {
  color: #5d5d5e;
  font-size: 1rem;
  line-height: 1.25;
  text-align: center;
}
@media (min-width: 950px) {
  .welcome-pop__hero-card-login {
    text-align: left;
    color: #1a1e22;
    line-height: 1.625;
  }
}
.welcome-pop__hero-card-login button {
  color: #3d7c54;
  text-decoration: underline;
}
.welcome-pop__content {
  padding: 0 1.5rem;
}
.welcome-pop__content-layout {
  display: grid;
  grid-template-columns: auto;
  gap: 4rem 2.5rem;
  overflow: hidden;
  width: 100%;
  max-width: var(--content-max-width);
  margin: 0 auto;
}
@media (min-width: 1100px) {
  .welcome-pop__content-layout {
    grid-template-columns: repeat(2, auto);
  }
}
.welcome-pop__content-layout > div {
  overflow: hidden;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 2rem;
}
@media (min-width: 1100px) {
  .welcome-pop__content-layout > div {
    padding: 3rem;
    border: 1px solid #3d7c54;
    border-radius: 1rem;
    max-width: 100%;
  }
}
.welcome-pop__content-layout .welcome-heading__title {
  text-wrap: pretty;
}
.welcome-pop__content-right {
  padding-bottom: 1.25rem !important;
}
.welcome-pop .react-multi-carousel-list {
  border: 1px solid #e6f5ee;
  border-radius: 1rem;
}
.welcome-pop__back-to-top {
  display: flex;
  place-content: center;
  margin-top: 2.5rem;
}
@media (min-width: 1300px) {
  .welcome-pop__back-to-top {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/dist/sage-home-loans/welcome-pop.css"],"names":[],"mappings":"AAAA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,aAAa;EACb,mBAAmB;EACnB,4BAA4B;EAC5B,8BAA8B;EAC9B,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,2CAA2C;EAC3C,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,qBAAqB;EACvB;AACF;AACA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,cAAc;AAChB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,yBAAyB;EACzB,gDAAgD;AAClD;AACA;EACE;IACE,kBAAkB;IAClB,gCAAgC;IAChC,gBAAgB;EAClB;AACF;AACA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,8BAA8B;EAC9B,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AAEA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;AAEA;EACE,wBAAwB;EACxB,sBAAsB;AACxB;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;AACf;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,sCAAsC;EACtC,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,YAAY;AACd;AAEA;EACE,UAAU;AACZ;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,yBAAyB;EACzB,6BAA6B;EAC7B,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,YAAY;AACd;AAEA;EACE,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,WAAW;AACb;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;EACE;IACE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,0BAA0B;EAC5B;AACF;AACA;EACE,qFAAqF;EACrF,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE;IACE,uBAAuB;IACvB,kBAAkB;EACpB;AACF;AACA;EACE;IACE,uBAAuB;EACzB;AACF;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,UAAU;AACZ;AACA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,2BAA2B;AAC7B;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE,gCAAgC;EAChC,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,UAAU;EACV,kBAAkB;AACpB;AACA;EACE;IACE,8BAA8B;IAC9B,WAAW;IACX,iBAAiB;EACnB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE;IACE,sBAAsB;EACxB;AACF;AACA;EACE,iBAAiB;AACnB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE;IACE,oBAAoB;IACpB,gBAAgB;EAClB;AACF;AACA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,iDAAiD;EACjD,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;AACA;EACE;IACE,2BAA2B;EAC7B;AACF;AACA;EACE;IACE,2BAA2B;IAC3B,6CAA6C;EAC/C;AACF;AACA;EACE;IACE,oBAAoB;EACtB;AACF;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE,SAAS;EACT,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE;IACE,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;EAClB;AACF;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,oBAAoB;EACpB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,2CAA2C;EAC3C,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;AACA;EACE;IACE,oBAAoB;IACpB,WAAW;EACb;AACF;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,aAAa;EACb,cAAc;EACd,kCAAkC;AACpC;AACA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE;IACE,gBAAgB;IAChB,cAAc;IACd,kBAAkB;EACpB;AACF;AACA;EACE,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,mCAAmC;EACnC,cAAc;AAChB;AACA;EACE;IACE,sCAAsC;EACxC;AACF;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE;IACE,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;EACjB;AACF;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":["/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.welcome-button {\n  display: flex;\n  flex-direction: row;\n  padding: 16px 12px 24px 12px;\n  justify-content: space-between;\n  height: 93px;\n  border: 1px solid #dddddd;\n  border-radius: 5px;\n  margin-bottom: 26px;\n}\n.welcome-button:hover {\n  box-shadow: 0 4px 14px 0 rgba(0, 0, 0, 0.2);\n  cursor: pointer;\n}\n.welcome-button:last-of-type {\n  margin-bottom: 0;\n}\n.welcome-button__text {\n  font-weight: 600;\n  font-size: 14px;\n  letter-spacing: 1px;\n  color: #1a1e22;\n  text-transform: uppercase;\n  margin-top: 12px;\n}\n.welcome-button__arrow {\n  transform: rotate(-90deg);\n  width: 16px;\n  height: 11px;\n  align-self: center;\n}\n\n@media (min-width: 400px) {\n  .welcome-button {\n    padding: 16px 24px 24px 24px;\n  }\n  .welcome-button__text {\n    font-weight: 600;\n    font-size: 18px;\n    letter-spacing: 1.3px;\n  }\n}\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.welcome-header {\n  width: 100%;\n}\n.welcome-header__content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.875rem 0;\n  height: auto;\n  box-shadow: none;\n  width: 100%;\n  margin: 0 auto;\n}\n.welcome-header__logo {\n  width: auto;\n  height: 4.375rem;\n}\n.welcome-header__phone-button {\n  font-size: 14px;\n  margin-left: auto;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 1.25rem;\n  border-radius: 3.5rem;\n  font-weight: 600;\n  text-align: center;\n  line-height: 1.5rem;\n  transition: all 0.2s;\n  cursor: pointer;\n  border: none;\n}\n.welcome-header__phone-icon {\n  max-width: 2rem;\n  max-height: 2rem;\n}\n\n.welcome-header--simple {\n  padding: 0 1rem;\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  background-color: #ffffff;\n  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.1);\n}\n@media (min-width: 750px) {\n  .welcome-header--simple {\n    position: relative;\n    border-bottom: 1px solid #d9d9d9;\n    box-shadow: none;\n  }\n}\n.welcome-header--simple .welcome-header__content {\n  max-width: 37.5rem;\n}\n@media (min-width: 1300px) {\n  .welcome-header--simple .welcome-header__content {\n    max-width: 80rem;\n  }\n}\n.welcome-header--simple .welcome-header__phone-button {\n  background-color: #e6f5ee;\n  color: #3d7c54;\n}\n.welcome-header--simple .welcome-header__phone-button:focus-visible, .welcome-header--simple .welcome-header__phone-button:hover {\n  background-color: #3d7c54;\n  color: #ffffff;\n}\n\n.welcome-header--pop {\n  background: transparent;\n}\n.welcome-header--pop .welcome-header__content {\n  max-width: var(--hero-max-width);\n}\n.welcome-header--pop .welcome-header__phone-button {\n  background-color: #ffffff;\n  color: #3d7c54;\n}\n.welcome-header--pop .welcome-header__phone-button:focus-visible, .welcome-header--pop .welcome-header__phone-button:hover {\n  background-color: #e6f5ee;\n}\n\n.welcome-feature-list {\n  display: grid;\n  grid-template-columns: max-content 1fr;\n  gap: 0.75rem 1.5rem;\n  margin: 0 !important;\n  align-items: center;\n  font-size: 1rem;\n  line-height: 1.25;\n  color: #1a1e22;\n}\n.welcome-feature-list:has(.welcome-feature-list__title) {\n  gap: 2rem 1.5rem;\n}\n.welcome-feature-list:has(.welcome-feature-list__title) .welcome-feature-list__item {\n  grid-template-rows: auto auto;\n}\n.welcome-feature-list__item {\n  display: grid;\n  grid-column: 1/-1;\n  grid-template-columns: subgrid;\n  margin-bottom: 0 !important;\n  align-items: center;\n}\n.welcome-feature-list__icon {\n  width: 3rem;\n  height: 3rem;\n  grid-column: 1/span 1;\n  grid-row: 1/-1;\n  align-self: start;\n}\n.welcome-feature-list__icon img {\n  width: 100%;\n  height: 100%;\n}\n.welcome-feature-list__title {\n  display: block;\n  font-weight: 700;\n  margin-bottom: 0.75rem;\n  grid-column: 2/span 1;\n}\n.welcome-feature-list__copy {\n  grid-column: 2/span 1;\n}\n.welcome-feature-list__copy sup {\n  color: #4e7b57;\n}\n\n.welcome-heading {\n  --eyebrow-color: #246464;\n  --title-color: #000000;\n  margin-bottom: 1rem;\n}\n.welcome-heading__eyebrow {\n  margin-bottom: 0.5rem;\n  color: var(--eyebrow-color);\n  font-size: 0.875rem;\n  line-height: 1.2;\n  font-weight: 600;\n  margin-bottom: 0.5625rem;\n  text-transform: uppercase;\n  letter-spacing: 0.125rem;\n}\n.welcome-heading__title {\n  font-weight: 600;\n  color: var(--title-color);\n}\n.welcome-heading__title:where(h1) {\n  font-size: 1.75rem;\n  line-height: 1.25;\n}\n@media (min-width: 750px) {\n  .welcome-heading__title:where(h1) {\n    font-size: 2.25rem;\n  }\n}\n.welcome-heading__title:where(h2) {\n  font-size: 1.3125rem;\n  line-height: 1.5;\n}\n\n.welcome-heading--white {\n  --eyebrow-color: #ffffff;\n  --title-color: #ffffff;\n}\n\n.testimonials__container {\n  position: relative;\n  min-width: 0;\n  min-height: 0;\n}\n.testimonials__card {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n  border-radius: 1rem;\n  padding: 1rem 1.25rem;\n}\n.testimonials__content {\n  font-size: 1rem;\n  line-height: 1.625;\n  color: #000000;\n}\n.testimonials__citation {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: center;\n  gap: 1rem;\n}\n.testimonials__reviewer {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  gap: 1rem;\n  line-height: 1.5;\n}\n.testimonials__avatar {\n  width: 3rem;\n  height: 3rem;\n  border-radius: 50%;\n  background-color: #e0f2ea;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #2a805b;\n  font-weight: bold;\n  font-size: 1.25rem;\n  flex: 0 0 auto;\n}\n.testimonials__name {\n  font-size: 1.125rem;\n  flex: 1 1 auto;\n}\n.testimonials__date {\n  color: #595959;\n}\n.testimonials__rating {\n  display: flex;\n  align-items: center;\n  gap: 0.125rem;\n}\n.testimonials__source {\n  font-size: 0.75rem;\n  color: #595959;\n}\n.testimonials__link {\n  text-decoration: underline;\n}\n.testimonials__nav-container {\n  display: flex;\n  justify-content: center;\n  margin-top: 1rem;\n  gap: 1rem;\n}\n.testimonials__arrow {\n  position: static;\n  width: 2.5rem;\n  height: 2.5rem;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  background-color: #4e7b57;\n  color: white;\n}\n.testimonials__arrow:focus-visible, .testimonials__arrow:hover {\n  background-color: #246464;\n}\n.testimonials__arrow svg {\n  width: 2rem;\n  height: 2rem;\n}\n\n.react-multi-carousel-list {\n  padding: 0;\n}\n\n.welcome-back-to-top {\n  font-size: 14px;\n  padding: calc(1rem - 1px);\n  border-radius: 3.5rem;\n  font-weight: 600;\n  text-align: center;\n  line-height: 1.5rem;\n  transition: all 0.2s;\n  cursor: pointer;\n  border: 1px solid #3d7c54;\n  background-color: transparent;\n  color: #3d7c54;\n  min-width: 10rem;\n}\n.welcome-back-to-top:focus-visible, .welcome-back-to-top:hover {\n  background-color: #3d7c54;\n  color: white;\n}\n\n.welcome-footer {\n  max-width: 100%;\n  width: 100%;\n  padding: 2.5rem 1rem 2rem;\n  align-self: end;\n  text-wrap: pretty;\n}\n.welcome-footer__disclaimer {\n  color: #5d5d5e;\n  font-size: 0.625rem;\n  line-height: 2;\n  margin: 0 auto 2rem;\n  max-width: 58.25rem;\n}\n.welcome-footer__disclaimer ol {\n  padding-left: 1rem;\n}\n.welcome-footer__disclaimer li {\n  list-style-type: auto;\n  width: 100%;\n}\n.welcome-footer__disclaimer li::marker {\n  color: #4e7b57;\n  font-weight: 700;\n}\n.welcome-footer .footer__compliance-container {\n  max-width: 100%;\n  width: 100%;\n}\n\n.welcome-pop {\n  --hero-max-width: 30.75rem;\n  --content-max-width: 30.75rem;\n}\n@media (min-width: 950px) {\n  .welcome-pop {\n    --hero-max-width: 70rem;\n  }\n}\n@media (min-width: 1100px) {\n  .welcome-pop {\n    --content-max-width: 70rem;\n  }\n}\n.welcome-pop__hero {\n  background: radial-gradient(at 60% bottom, rgb(18, 84, 42) 0%, rgb(61, 124, 84) 100%);\n  padding: 0 1.5rem;\n  position: relative;\n  margin-bottom: 3.75rem;\n}\n@media (min-width: 950px) {\n  .welcome-pop__hero {\n    padding-bottom: 4.75rem;\n    margin-bottom: 1px;\n  }\n}\n@media (min-width: 1100px) {\n  .welcome-pop__hero {\n    padding-bottom: 3.75rem;\n  }\n}\n.welcome-pop__hero-bg-image {\n  width: 100%;\n  overflow: hidden;\n  height: 12.75rem;\n  position: absolute;\n  bottom: -1px;\n  left: 0;\n  right: 0;\n  z-index: 0;\n}\n.welcome-pop__hero-bg-image svg {\n  width: 90rem;\n  height: 100%;\n  position: relative;\n  left: 50%;\n  transform: translateX(-50%);\n}\n@media (min-width: 90em) {\n  .welcome-pop__hero-bg-image svg {\n    width: 100%;\n  }\n}\n.welcome-pop__hero-layout {\n  max-width: var(--hero-max-width);\n  margin: 0 auto;\n  padding-top: 1.5rem;\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 2rem;\n  z-index: 1;\n  position: relative;\n}\n@media (min-width: 950px) {\n  .welcome-pop__hero-layout {\n    grid-template-columns: 1fr 1fr;\n    gap: 2.5rem;\n    padding-top: 3rem;\n  }\n}\n@media (min-width: 1100px) {\n  .welcome-pop__hero-layout {\n    padding-top: 1rem;\n  }\n}\n.welcome-pop__hero-left {\n  max-width: 29.5rem;\n  color: #ffffff;\n}\n@media (min-width: 950px) {\n  .welcome-pop__hero-left .welcome-heading__eyebrow {\n    margin-bottom: 1.25rem;\n  }\n}\n.welcome-pop__hero-left .welcome-heading__title {\n  text-wrap: pretty;\n}\n@media (min-width: 1100px) {\n  .welcome-pop__hero-left .welcome-heading__title {\n    font-size: 3rem;\n  }\n}\n.welcome-pop__hero-description {\n  font-size: 1rem;\n  line-height: 1.625;\n}\n@media (min-width: 1300px) {\n  .welcome-pop__hero-description {\n    font-size: 1.3125rem;\n    line-height: 1.2;\n  }\n}\n.welcome-pop__hero-card {\n  background-color: #fff;\n  border-radius: 1rem;\n  box-shadow: 0 0.25rem 0.25rem rgba(0, 0, 0, 0.25);\n  padding: 1.5rem 1.5rem 2rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n@media (min-width: 750px) {\n  .welcome-pop__hero-card {\n    padding: 1.5rem 2.5rem 2rem;\n  }\n}\n@media (min-width: 950px) {\n  .welcome-pop__hero-card {\n    padding: 1.5rem 2rem 1.5rem;\n    box-shadow: 0 0.25rem 1rem rgba(0, 0, 0, 0.2);\n  }\n}\n@media (min-width: 1100px) {\n  .welcome-pop__hero-card {\n    padding: 2rem 2.5rem;\n  }\n}\n@media (min-width: 1100px) {\n  .welcome-pop__hero-card {\n    padding: 2rem 3rem;\n  }\n}\n.welcome-pop__hero-card-title {\n  margin: 0;\n  font-size: 1.3125rem;\n  line-height: 1.5;\n  font-weight: 600;\n  margin-bottom: 0.375rem;\n}\n@media (min-width: 1100px) {\n  .welcome-pop__hero-card-title {\n    font-size: 2.25rem;\n    line-height: 1.3;\n    margin-bottom: 0;\n  }\n}\n.welcome-pop__hero-card-description {\n  font-size: 1rem;\n  line-height: 1.625;\n}\n.welcome-pop__cta-buttons {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n.welcome-pop .welcome-button {\n  padding: 1rem 1.5rem;\n  margin: 0;\n  width: 100%;\n  align-items: center;\n  gap: 1rem;\n  display: grid;\n  grid-template-columns: auto 1fr max-content;\n  height: auto;\n  padding: 1rem;\n  text-align: left;\n}\n@media (min-width: 750px) {\n  .welcome-pop .welcome-button {\n    padding: 1rem 1.5rem;\n    gap: 1.5rem;\n  }\n}\n.welcome-pop .welcome-button img {\n  max-height: 2.5rem;\n  max-width: 3rem;\n}\n@media (min-width: 750px) {\n  .welcome-pop .welcome-button img {\n    max-width: 100%;\n  }\n}\n.welcome-pop .welcome-button__text {\n  margin-top: 0;\n  line-height: 1;\n  text-box: trim-both cap alphabetic;\n}\n.welcome-pop__hero-card-login {\n  color: #5d5d5e;\n  font-size: 1rem;\n  line-height: 1.25;\n  text-align: center;\n}\n@media (min-width: 950px) {\n  .welcome-pop__hero-card-login {\n    text-align: left;\n    color: #1a1e22;\n    line-height: 1.625;\n  }\n}\n.welcome-pop__hero-card-login button {\n  color: #3d7c54;\n  text-decoration: underline;\n}\n.welcome-pop__content {\n  padding: 0 1.5rem;\n}\n.welcome-pop__content-layout {\n  display: grid;\n  grid-template-columns: auto;\n  gap: 4rem 2.5rem;\n  overflow: hidden;\n  width: 100%;\n  max-width: var(--content-max-width);\n  margin: 0 auto;\n}\n@media (min-width: 1100px) {\n  .welcome-pop__content-layout {\n    grid-template-columns: repeat(2, auto);\n  }\n}\n.welcome-pop__content-layout > div {\n  overflow: hidden;\n  width: 100%;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n@media (min-width: 1100px) {\n  .welcome-pop__content-layout > div {\n    padding: 3rem;\n    border: 1px solid #3d7c54;\n    border-radius: 1rem;\n    max-width: 100%;\n  }\n}\n.welcome-pop__content-layout .welcome-heading__title {\n  text-wrap: pretty;\n}\n.welcome-pop__content-right {\n  padding-bottom: 1.25rem !important;\n}\n.welcome-pop .react-multi-carousel-list {\n  border: 1px solid #e6f5ee;\n  border-radius: 1rem;\n}\n.welcome-pop__back-to-top {\n  display: flex;\n  place-content: center;\n  margin-top: 2.5rem;\n}\n@media (min-width: 1300px) {\n  .welcome-pop__back-to-top {\n    display: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
